import { connect } from 'react-redux';
import {
    clearAll,
    getSearchStats,
    groupStatsBy,
    setFormField,
    setSelectedWhatSuggestions,
    setSelectedWhereSuggestions,
} from '../../reduxStore/config/searchstats';
import { logout } from '../../reduxStore/config/user';
import mapSearchStatsToTable from './searchStatisticsTableAdapter';
import mapStatsToLineChart from '../../utils/chartAdapter/lineChartAdapter';
import SearchStatsWrapper from './SearchStatsWrapper';

const mapStateToProps = (state, ownProps) => {
    const {
        formState,
        graphDataPoint,
        graphDate,
        groupBy,
        selectedWhatSuggestions,
        selectedWhereSuggestions,
        stats,
    } = state.searchstats;

    const {
        preferedLanguage,
        user,
    } = state.user;

    const {
        searchSummary,
        totalSearchCount,
    } = stats;

    const {
        translation,
    } = ownProps;

    return {
        graphData: graphDataPoint && graphDate ? mapStatsToLineChart(
            graphDataPoint,
            graphDate,
            groupBy,
            translation,
        ) : null,

        tableData: searchSummary ? mapSearchStatsToTable(
            searchSummary,
            translation,
        ) : null,

        allSearches: searchSummary ? searchSummary
            .sort((a, b) => b.count - a.count)
            .map(search => search.search)
            .splice(0, 29)
            : null,
        allSearchesCount: searchSummary ? searchSummary.length : 0,
        formState,
        groupBy,
        isAdvancedUser: user ? user.isAdvancedUser : null,
        isLoading: state.ui.isLoading,
        noResult: totalSearchCount === 0,
        searchActive: totalSearchCount !== undefined,
        selectedWhatSuggestions,
        selectedWhereSuggestions,
        totalCount: totalSearchCount,
        totalCountString: totalSearchCount ? totalSearchCount.toLocaleString('sv-se') : null,
        translation,
        userLocale: preferedLanguage,
    };
};

const mapDispatchToProps = dispatch => ({
    handleLogOut: (forced) => {
        dispatch(logout(forced));
    },
    handleClear: () => {
        dispatch(clearAll());
    },
    handleSubmit: (formData) => {
        dispatch(getSearchStats(formData));
    },
    handleGroupBy: (groupBy) => {
        dispatch(groupStatsBy(groupBy));
    },
    handleUpdateFormField: (field) => {
        dispatch(setFormField(field));
    },
    handleSelectWhatSuggestion: (selected) => {
        dispatch(setSelectedWhatSuggestions(selected));
    },
    handleSelectWhereSuggestion: (selected) => {
        dispatch(setSelectedWhereSuggestions(selected));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(SearchStatsWrapper);
